import { render, staticRenderFns } from "./alghoritm.vue?vue&type=template&id=3980bf56&scoped=true"
import script from "./alghoritm.vue?vue&type=script&lang=js"
export * from "./alghoritm.vue?vue&type=script&lang=js"
import style0 from "./alghoritm.vue?vue&type=style&index=0&id=3980bf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980bf56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VSelect})
